import { HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConfigurationService } from '@sondermind/configuration';
import { PROVIDER_INDEX_AUTHENTICATED } from '../tokens/provider-index-authenticated.token';

@Injectable({
  providedIn: 'root'
})
export class UrlTargetService {
  private readonly providerIndexAuthenticated = inject(PROVIDER_INDEX_AUTHENTICATED);

  constructor(
    private configurationService: ConfigurationService
  ) {}

  targetsSonderMindApis(req: HttpRequest<unknown>): boolean {
    const { url } = req;
    const configEnv = this.configurationService.env;

    const bases = [
      configEnv.apiBase,
      configEnv.svcBase,
      configEnv.authBase,
      configEnv.notificationSvcBase,
      configEnv.proxyCommunicationSvcBase,
      configEnv.providerMetricsSvcBase,
      configEnv.miniformApiBase,
      configEnv.clinicalAssessmentsSvcBase,
      configEnv.clinicalInsightsSvcBase,
      configEnv.dataExchangeSvcBase,
      configEnv.schedulingSvcBase,
      configEnv.schedulingCoreSvcBase,
      configEnv.adminBase,
      configEnv.conciergeSvcBase,
      configEnv.engagementApiBase,
      configEnv.goalsSvcBase,
      configEnv.resourceSvcBase,
      configEnv.providerUiSvcBase,
      configEnv.contentSvcBase,
      configEnv.clientBillingUiSvcBase,
      configEnv.providerFaqResourceSvcBase,
      configEnv.smPubnubApiBase,
      // provider-index is anonymous except for its race/ethnicity filter and facet, which require an
      // admin token — attaching one is what lets the admin portal use them. Included only for an app
      // that opts in, so an app whose users are never admins does not send its tokens here at all;
      // see PROVIDER_INDEX_AUTHENTICATED.
      ...(this.providerIndexAuthenticated ? [configEnv.providerIndexSvcBase] : []),
      // `claimsServiceBase` is deliberately absent. ClaimsEnrichmentService attaches its own
      // Authorization and X-Provider-Id per request; adding it here would double-attach and
      // override the caller's admin-impersonation context.
    ];

    return bases.some((base) => {
      if (!base) return false;

      try {
        const parsedUrl = new URL(url);
        const baseUrl = new URL(base);
        return parsedUrl.origin === baseUrl.origin;
      } catch {
        return url.startsWith(base);
      }
    });
  }
}
